const CompanysAhan = [
    {ID: -1 , Name : "All Items" , CompanyCategoryId: [2001 , 2002 , 2003 ,2004]},
    {ID: 1 , Name : "Tehran" , CompanyCategoryId: [2001]},
    {ID: 2 , Name : "Mazandaran Steel" , CompanyCategoryId: [2001]},
    {ID: 3 , Name : "Kaloup" , CompanyCategoryId: [2001]},
    {ID: 4 , Name : "Esfahan" , CompanyCategoryId: [2001 , 2004]},
    {ID: 5 , Name : "Arian Foolad" , CompanyCategoryId: [2002 , 2004]},
    {ID: 6 , Name : "Shekofteh" , CompanyCategoryId: [2002]},
    {ID: 7 , Name : "Naab Tabriz" , CompanyCategoryId: [2002]},
    {ID: 8 , Name : "Foolad Kouhpaye" , CompanyCategoryId: [2002]},
    {ID: 9 , Name : "Zohourian" , CompanyCategoryId: [2002]},
    {ID: 10 , Name : "Avangan" , CompanyCategoryId: [2002]},
    {ID: 11 , Name : "Manzoomeh" , CompanyCategoryId: [2002]},
    {ID: 12 , Name : "Sepehr Iranian" , CompanyCategoryId: [2002 , 2004]},
    {ID: 13 , Name : "Javid Bonab" , CompanyCategoryId: [2002]},
    {ID: 14 , Name : "Mahan Zoub" , CompanyCategoryId: [2002]},
    {ID: 15 , Name : "Nesta" , CompanyCategoryId: [2002]},
    {ID: 16 , Name : "Abhar" , CompanyCategoryId: [2002 , 2004]},
    {ID: 17 , Name : "Zanjan" , CompanyCategoryId: [2002]},
    {ID: 18 , Name : "Eshtehard" , CompanyCategoryId: [2002]},
    {ID: 19 , Name : "Zob Ahan" , CompanyCategoryId: [2003]},
    {ID: 20 , Name : "Faiko" , CompanyCategoryId: [2003 , 2004]},
    {ID: 21 , Name : "Yazd" , CompanyCategoryId: [2003]},
    {ID: 22 , Name : "Atlas" , CompanyCategoryId: [2003]},
    {ID: 23 , Name : "Bonab" , CompanyCategoryId: [2003 , 2004]},
    {ID: 24 , Name : "Mahan" , CompanyCategoryId: [2003]},
    {ID: 25 , Name : "Kermanshah" , CompanyCategoryId: [2003]},
    {ID: 26 , Name : "Neyshabur" , CompanyCategoryId: [2004]},
    {ID: 27 , Name : "Amir Kabir" , CompanyCategoryId: [2004]},
    {ID: 28 , Name : "Foolad Sirjan" , CompanyCategoryId: [2004]},
    {ID: 29 , Name : "Bafgh Yazd" , CompanyCategoryId: [2004]},
    {ID: 30 , Name : "Shahrood" , CompanyCategoryId: [2004]},
    {ID: 31 , Name : "Shahin Bonab" , CompanyCategoryId: [2004]},
    {ID: 32 , Name : "Zagros Steel" , CompanyCategoryId: [2004]},
    {ID: 33 , Name : "Hamedan" , CompanyCategoryId: [2004]},
    {ID: 34 , Name : "Anahita Gilan" , CompanyCategoryId: [2004]},
    {ID: 35 , Name : "Kashan" , CompanyCategoryId: [2004]},
    {ID: 36 , Name : "Ghaem" , CompanyCategoryId: [2004]},
    {ID: 37 , Name : "Semnan" , CompanyCategoryId: [2004]},
    {ID: 38 , Name : "Tikmeh Dash" , CompanyCategoryId: [2004]},
    {ID: 39 , Name : "Darpad Tabriz" , CompanyCategoryId: [2004]},
    {ID: 40 , Name : "Kosar Ahvaz" , CompanyCategoryId: [2004]},
    {ID: 41 , Name : "Persian Gulf" , CompanyCategoryId: [2004]},
    {ID: 42 , Name : "Hirbod" , CompanyCategoryId: [2004]},
    {ID: 43 , Name : "Abarghou" , CompanyCategoryId: [2004]},
    {ID: 44 , Name : "Pardis" , CompanyCategoryId: [2004]},
    {ID: 45 , Name : "Persian Foolad" , CompanyCategoryId: [2004]},
]
export default CompanysAhan;
